<template>
	<div>
		<CourseDate
				v-for="radioValue in radioValues"
				:id="radioValue.id"
				:key="radioValue.id"
				:courseEvent="courseEvent"
				:eventdate="radioValue"
				:modelValue="selected[radioValue.id]"
				:name="uuid"
				@update:modelValue="updateRadio(radioValue.id)"
				@use-proposed-dates="emit('UseProposedDates', $event)"
		>
			<div class="flex justify-between">
				<div>{{ radioValue.title }}</div>
				<div>
					<PriceAlert :value="radioValue" class="text-right"></PriceAlert>
				</div>
			</div>
			<template v-slot:comment>
				{{ radioValue.comment }}
			</template>
		</CourseDate>
	</div>
</template>

<script lang="ts" setup>
import PriceAlert from "../../../ui/PriceAlert.vue"
import CourseDate from "./CourseDate.vue"
import {nextTick, onMounted, reactive} from "vue"
import {EventdateInterface} from "@/js/interfaces/eventdate"
import {CartEventInterface} from "@/js/interfaces/event"

const props = defineProps<{
	courseEvent: CartEventInterface
	radioValues: EventdateInterface[]
	modelValue?: number | "custom" | null,
}>()
const emit = defineEmits(["UseProposedDates", "update:modelValue"])

const uuid = Math.random()

const selected = reactive({})

const emitSelected = () => {
	for (let key in selected) {
		if (selected[key] === true) {
			emit("update:modelValue", parseInt(key))
		}
	}
}

const updateRadio = (value: number): void => {
	for (let key in selected) {
		if (parseInt(key) === value) {
			selected[key] = true
		} else {
			selected[key] = false
		}
	}
	emitSelected()
}
const initGroup = () => {
	let c = 0
	props.radioValues.forEach((value) => {
		c += 1
		if (c === 1 && !props.modelValue) {
			selected[value.id] = true
		} else if (props.modelValue) {
			selected[value.id] = true
		} else {
			selected[value.id] = false
		}
	})
	nextTick(() => {
		emitSelected()
	})
}

onMounted(() => {
	initGroup()
})
</script>
